import React from 'react'
import { useNavigate } from 'react-router-dom'
import { labels } from '../../../labels'
import SvgIcon from '../../svgIcon/SvgIcon'
import Text from '../../text/Text'
import styles from './LiquidateCreateResponseOK.module.css'
interface ILiquidateCreateResponseOKProps {
    text: string
    buttonText: string
    onClose: () => void
    onlyCurrentBtn?: boolean
}
export default function LiquidateCreateResponseOK({
    onClose,
    buttonText,
    text,
    onlyCurrentBtn,
}: ILiquidateCreateResponseOKProps) {
    const navigate = useNavigate()
    const handleClose = () => {
        onClose()
        location.reload()
    }
    const goToInventory = () => {
        navigate('/inventory')
    }

    return (
        <div className={styles.successContainer}>
            <div className={styles.IconContainer} onClick={onClose}>
                <SvgIcon iconName="responseOK" />
            </div>
            <Text
                label={text}
                fontSize={16}
                fontWeight={500}
                textAlign="center"
                color="#565656"
                marginTop={10}
            />
            <div className={styles.buttonContainer}>
                <button
                    className={`ButtonSm-13 ${styles.successButton} ${styles.buttonItem}`}
                    style={{ cursor: 'pointer' }}
                    onClick={handleClose}
                    type="button"
                >
                    {buttonText}
                </button>
                {!onlyCurrentBtn && (
                    <button
                        className={`ButtonSm-13 successBC ${styles.buttonItem}`}
                        style={{ cursor: 'pointer' }}
                        onClick={goToInventory}
                        type="button"
                    >
                        {labels.goToProducts}
                    </button>
                )}
            </div>
        </div>
    )
}
